$(document).ready(function() {

    if($('.product__options input[type="radio"]').first().length > 0) {
        $('.product__options input[type="radio"]').first().trigger('change');
    }

    $.getJSON('/cart.js', function(cart){
        $('.cart-count').text(cart.item_count);
    });
    $('.product__options input[type="radio"]').change(function() {
        updateVariantSelect();
    });
    function updateVariantSelect() {
        var selectedValues = [];
        $('.product__options input[type="radio"]:checked').each(function() {
            var value = $(this).val();
            $(this).closest(".mainProduct__variantBlock").find(".mainProduct__variantValue").text(value);
            selectedValues.push(value);
        });
        var variantTitle = selectedValues.join(' / ');
        $('.product__options #variant-select option').each(function() {
            var optionValue = $(this).val();
            if (optionValue === variantTitle) {
                $(this).prop('selected', true);
                $(this).val(optionValue).trigger("change");
                $(this).addClass('selected').siblings().removeClass('selected');
            } else {
                $(this).prop('selected', false);
            }
        });
    }
    $(".variant-div1 select[name='id']").on("change", function (e) {
        var mf = "";
        function formatMoney(amount, format) {
            var value = (amount / 100).toFixed(2);
            return format.replace('', value);
        }
        var shop_url = $(this).children("option:selected").attr("data-shop-url");
        var variantId = $(this).children("option:selected").attr("data-variantid");
        var price = $(this).children("option:selected").attr("data-price");
        var variant_img = shop_url+"/cdn/shop/"+$(this).children("option:selected").attr("data-img-src"); 
        var savebadge =  $(this).closest('.cw-product-banner').find('.savebadge').text().replace('%', '');
        var subcribe_price = price - ((price * savebadge)/100).toFixed(2);

        $(this).closest('.cw-product-banner').find('.product-var-id').val(variantId);
        $(this).closest('.cw-product-banner').find('.main_price').text("$"+formatMoney(price, mf));
        $(this).closest('.cw-product-banner').find('.subscribe-price').text("$"+formatMoney(subcribe_price, mf));
        $(this).closest('.cw-product-banner').find('.original-price').text("$"+formatMoney(price, mf));
        if($(this).closest('.cw-product-banner').find("input[type='radio'][name='purchase-option']:checked").val() === 'subscribe-save') {
            $(this).closest('.cw-product-banner').find('.addto__cart span').text("Add to cart - $"+formatMoney(subcribe_price, mf));
        }else{
            $(this).closest('.cw-product-banner').find('.addto__cart span').text("Add to cart - $"+formatMoney(price, mf));
        }
        $('.wn-product__gallery-thumb-slide').each(function(){
            var image_nav = "https:"+$(this).find(".nav_img").attr('data-pro-img'); 
            if(image_nav == variant_img ){
                $(this).trigger('click');
            }
        })
    });

    $("input[type='radio'][name='purchase-option']").change(function() {
        if ($(this).val() === 'subscribe-save') {
            $(this).closest('.cw-product-banner').find('.addto__cart span').text("Add to cart - "+ $(this).closest(".wn-product__purchase-options").find('.subscribe-price').text() );
        } else {
            $(this).closest('.cw-product-banner').find('.addto__cart span').text("Add to cart - "+$(this).closest(".wn-product__purchase-options").find('.original-price').text());
        }
    });

    $(document).on('click', '.addto__cart', function(e) {
        e.preventDefault();
        var variant_id = parseInt($(this).closest('.cw-product-banner').find('.product-var-id').val());
        var selling_id = parseInt($(this).closest('.cw-product-banner').find(".subcribe_plan").val());
        if($(this).closest('.cw-product-banner').find("input[type='radio'][name='purchase-option']:checked").val() === 'subscribe-save') {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                  id: variant_id,
                  quantity: 1,
                  selling_plan: selling_id,
                },
              }).done((data) => { 
                openCartDrawer();
              });
        }else{
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                id: variant_id,
                quantity: 1
                },
            }).done((data) => {
                openCartDrawer();
            });
        }
    });

    /* collection page variant change */
    $('.product__variant-wrapper .option-selector').on('change', function () {
        console.log("dsdf");
        let value = $(this).val();
        var selectedText = "";
        console.log(value,"val");
        $(this).closest(".variant-div").find(".single-product__option-wrapper").each(function () {
            $(this).find('.product__variant-wrapper .option-selector').each(function () {
                let e_val = $(this).val();
                if (value == e_val) {
                    $(this).prop('selected', true).siblings().prop('selected', false);
                }
                var currentValue = $.trim($(this).val());
                if (selectedText !== null && selectedText !== "") {
                    selectedText = selectedText + " / " + currentValue;
                } else {
                    selectedText = currentValue;
                }
            });
        });
    
        console.log(selectedText,"selectedText");
        if (typeof selectedText !== "undefined" && selectedText !== null && selectedText !== "") {
            var parentFormWrapper = $(this).closest('.variant-div');
            var selectDropdown = $(parentFormWrapper).find('#variant-select');
            if (selectDropdown.length > 0) {
                selectDropdown.find('option').each(function () {
                    var currentText = $.trim($(this).text());
                    if (currentText === selectedText) {
                        selectDropdown.val($(this).val()).trigger("change");
                        $(this).addClass('selected').siblings().removeClass('selected');
                    }
                });
            }
        }
    });

    $(".variant-div select[name='id']").on("change", function (e) {
        var mf = "";
        function formatMoney(amount, format) {
            var value = (amount / 100).toFixed(2);
            return format.replace('', value);
        }
        var shop_url = $(this).children("option:selected").attr("data-shop-url");
        var variantId = $(this).children("option:selected").attr("data-variantid");
        var price = $(this).children("option:selected").attr("data-price");
        var inventory = $(this).children("option:selected").attr("data-inventory");
        var variant_img = shop_url+"/cdn/shop/"+$(this).children("option:selected").attr("data-img-src"); 
        var savebadge =  $(this).closest('.box-wrap').find('.savebadge').text().replace('%', '');
        var subcribe_price = price - ((price * savebadge)/100).toFixed(2);
        $(this).closest('.box-wrap').find('.product-var-id').text(variantId);
        $(this).closest('.box-wrap').find('.product__grid__price .price').text("$"+formatMoney(price, mf));
        $(this).closest('.box-wrap').find('.product-grid-item__image').attr('srcset',variant_img);
        console.log(inventory,"inventory");
        if(inventory > 0){
            $(this).closest('.box-wrap').find('.cw-btn__light span').text("Add To Cart");
            $(this).closest('.box-wrap').find('.cw-btn__light span').removeClass("soldout");
        }else{
            $(this).closest('.box-wrap').find('.cw-btn__light span').text("Soldout");
            $(this).closest('.box-wrap').find('.cw-btn__light span').addClass("soldout");
        }
    });

    $(document).on('click', '.addTo--cart', function(e) {
        e.preventDefault();
        var variant_id = parseInt($(this).closest('.box-wrap').find('.product-var-id').text());
        var qty = $(this).closest('.box-wrap').find('.product-quantity-counter__input').val();
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                id: variant_id,
                quantity: qty
                },
            }).done((data) => {
                openCartDrawer();
               
            });
    });

    /* klaviyo reviews start */
        // Function to get the review rate and count once they are available
        function getKlaviyoReviewData() {
            var klaviyo_review_rate = $(".kl_reviews__summary__average_value").text().trim();
            var klaviyo_total_count = $(".kl_reviews__star_rating_widget__label").text().trim();
            klaviyo_total_count = klaviyo_total_count.replace(/[^\d]/g, '');
            if (klaviyo_total_count.length > 2) {
                klaviyo_total_count = klaviyo_total_count.slice(0, 2);
            }
            var review_rate = Math.floor(parseFloat(klaviyo_review_rate)); // Convert to a number and get the integer part
            var remain_star = parseFloat(klaviyo_review_rate) - review_rate; // Fractional part of the review rate
            var $starContainer = $(".star-rating"); // Use class selector

            // Clear previous stars
                $starContainer.empty();

                // Get review rate and remaining star
                var klaviyoReviewRate = $(".kl_reviews__summary__average_value").text().trim();
                var klaviyoTotalCount = $(".kl_reviews__star_rating_widget__label").text().trim();
                klaviyoTotalCount = klaviyoTotalCount.replace(/[^\d]/g, '');
                if (klaviyoTotalCount.length > 2) {
                    klaviyoTotalCount = klaviyoTotalCount.slice(0, 2);
                }
                var reviewRate = Math.floor(parseFloat(klaviyoReviewRate)); // Convert to a number and get the integer part
                var remainStar = parseFloat(klaviyoReviewRate) - reviewRate; // Fractional part of the review rate

                // Loop to add full stars to the container
                for (var i = 0; i < reviewRate; i++) {
                    $("<span>").addClass("full-star").css("color", "black").appendTo($starContainer);
                }

                // Add a half star if needed
                if (remainStar >= 0.5) {
                    $("<span>").addClass("half-star").appendTo($starContainer);
                }

                // Add empty stars to fill up to 5 stars
                var totalStars = 5;
                for (var i = reviewRate + (remainStar >= 0.5 ? 1 : 0); i < totalStars; i++) {
                    $("<span>").addClass("empty-star").appendTo($starContainer);
                }




            var review_line = `<p><b>${klaviyo_review_rate}</b> | Based on <b>${klaviyo_total_count}</b> Happy Customer Reviews</p>`;
            $('.review_line').html(review_line);
            // You can now use these values to update the page or for further logic
        }
        // Function to observe changes in the DOM
        function observeKlaviyoContent() {
            // Target the container where Klaviyo content is loaded
            var targetNode = document.body; // You can be more specific if you know the exact container
            var config = { childList: true, subtree: true }; // Observe direct children and all sub-tree elements

            // Create a callback function to execute when mutations are observed
            var callback = function(mutationsList, observer) {
                for (var mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        // Check if the elements we are interested in have been added to the DOM
                        if ($(".kl_reviews__summary__average_value").length > 0 && $(".kl_reviews__star_rating_widget__label").length > 0) {
                            getKlaviyoReviewData(); // Call the function to get the review data
                            observer.disconnect(); // Once found, disconnect the observer
                            break;
                        }
                    }
                }
            };

            // Create an observer instance linked to the callback function
            var observer = new MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }
        observeKlaviyoContent();
    /* klaviyo review end */

}); 

$(document).on('change', 'input[name="purchase-option"]', function(e) {
  let radioValue = $(this).val();
  if(radioValue == 'subscribe-save'){
    $('.subcribe_plan').show();
    $('.save-text').show();
    $('.price-text--subscription-price').show();
    $('.otp-price').hide();
  }else{
    $('.save-text').hide();
    $('.subcribe_plan').hide();
    $('.price-text--subscription-price').hide();
     $('.otp-price').show();
  }

});

 $(document).on("change", ".js_parent--box .product_dropdown", function(e) {

    let option1 = option2 = option3 = null;
    let parent = $(e.target).closest('.js_parent--box');
    var product_id = parent.find(".product_dropdown option:selected").val();
    if (parent.find('[data-option-1]').length > 0) {
        option1 = parent.find('[data-option-1] option:selected').val();

    }

    if (parent.find('[data-option-2]').length > 0) {
        option2 = parent.find('[data-option-2] option:selected').val();
    }
    if (parent.find('[data-option-3]').length > 0) {
        option3 = parent.find('[data-option-3] option:selected').val();
    }

    let variant_id = null;
    let current_selected_option = null;

    if (option2 == null & option3 == null) {
        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`)).val();
    }
    if (option2 != null & option3 == null) {

        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`)).val();
    }
    if (option2 != null & option3 != null) {

        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`)).val();
    }
    let price = $(current_selected_option).attr('data-price');
     $(parent.find(`.js_price`)).text(price);
    let comPrice = $(current_selected_option).attr('data-compareat-price');

    let is_available = $(current_selected_option).attr('data-available');
    let variantImage = (current_selected_option).data('image');

    if (variantImage) {
        $(parent.find(`.js_imgbox img`)).attr('src', variantImage);
    }
    $(parent.find(`select.actual-variantss`)).val(variant_id).trigger('change');
    if (is_available == 'true') {
        $(parent.find(`.js_home_page_atc span`)).text('add to cart');
        $(parent.find(`.js_home_page_atc span`)).css('pointer-events', 'all');
        $(parent.find(`.js_home_page_atc span`)).css('opacity', '1');
    } else {
        $(parent.find(`.js_home_page_atc span`)).text('sold out');
        $(parent.find(`.js_home_page_atc span`)).css('pointer-events', 'none');
        $(parent.find(`.js_home_page_atc span`)).css('opacity', '0.5');
    }
});


$(document).on('click', '.js_parent--box .js_home_page_atc', function(e) {
    e.preventDefault();
    let parent = $(e.target).closest('.js_parent--box');
    let varId = parent.find("select.actual-variantss option:selected").val();
    let varQty = parent.find(".js_input-box").val();

    $.ajax({
        url: "/cart/add.js",
        data: {
            id: varId,
            quantity: 1
        },
        method: "POST",
        dataType: "JSON",
        success: function(data) {
            openCartDrawer();
        },
        error: function(data) {
            window.alert(data.responseJSON.description);
        }
    });
});

$(window).on('load', function() {
    if ($('.product__options input[type="radio"]').first().length > 0) {
        $('.product__options input[type="radio"]').first().trigger('change');
    }
   
});

$(document).ready(function() {
    $('.product_dropdown').trigger('change');
});

$(document).on('change', '.cart-drawer-qty-update', function(){  

    var selectedValue = $(this).val();
      console.log(selectedValue)
    var variantId = $(this).attr('data-quantity-variant-id');  
    var apiUrl = '/cart/change.js'; 
    var data = {
      id: variantId, 
      quantity: selectedValue 
    };
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
    //   console.log('Cart updated', cart);
      openCartDrawer() 
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  })

  $(document).on('click', '.remove-cart-item', function(){  
        let lineItemKey = $(this).attr('data-product-item-key')
        var data = {
          id: lineItemKey, 
          quantity: 0 
        };

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(cart => {
        //   console.log('Cart updated after removal', cart); 
          openCartDrawer()            
        })
        .catch(error => {
          console.error('Error removing item from cart:', error);
        });
  })
  // cart drawer quantity update js end here


  

function openCartDrawer(){
    $.getJSON('/cart.js', function(cart){
        $('.cart-count').text(cart.item_count);
    });
    var apiUrlDrawer = '/cart?view=drawer'; 
    fetch(apiUrlDrawer)
    .then(response => {
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.text(); 
    })
    .then(htmlData => {
    console.log($(htmlData).find('.cw-side-cart')); 
    $('aside.cw-side-cart').html($(htmlData).find('.cw-side-cart .cw-side-cart__wrap'))
    let progress = document.querySelector('.progress-done');
    if(progress){
    progress.style.width = progress.getAttribute('data-done') + '%';
    progress.style.opacity = 1;
    }
    $('body').addClass('open-side-cart');
    })
    .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
    });
}